module.exports = __webpack_public_path__ + "img/question12c4.a66821c1.png";